import { defineMessages } from 'react-intl';

export default defineMessages({
  premiumFeature: {
    id: 'am-config.menu.premuium-feature',
    defaultMessage: 'Premium Feature',
  },
  lockedHeader: {
    id: 'am-config.locked.header',
    defaultMessage: 'Unlock {version}',
  },
  lockedCompetitorsSubheader: {
    id: 'am-config.locked.competitors.subheader',
    defaultMessage: 'Provide compelling messages to students interested in your competitors.',
  },
  lockedMajorsSubheader: {
    id: 'am-config.locked.majors.subheader',
    defaultMessage: 'Provide compelling messages to students interested in majors offered by your institution.',
  },
  lockedDiversitySubheader: {
    id: 'am-config.locked.diversity.subheader',
    /* eslint-disable max-len */
    defaultMessage: 'Select the student racial/ethnic minority group(s) that you would like to see messages and/or be asked to connect with your institution.',
    /* eslint-enable max-len */
  },
  lockedDefaultSubheader: {
    id: 'am-config.locked.default.subheader',
    defaultMessage: '-',
  },
  lockedUpgrade: {
    id: 'am-config.locked.upgrade',
    defaultMessage: 'Upgrade',
  },
});
